import { render, staticRenderFns } from "./formAddress.vue?vue&type=template&id=5723f7c8&scoped=true&"
import script from "./formAddress.vue?vue&type=script&lang=js&"
export * from "./formAddress.vue?vue&type=script&lang=js&"
import style0 from "./formAddress.vue?vue&type=style&index=0&id=5723f7c8&lang=scss&scoped=true&"
import style1 from "./formAddress.vue?vue&type=style&index=1&id=5723f7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723f7c8",
  null
  
)

export default component.exports